import request from '@/utils/requestLongTime'
import requestNoToken from '@/utils/requestNoToken'
import Qs from 'qs'

export function goodsList(query) {
  return requestNoToken({
    url: '/index/goodsList',
    method: 'get',
    params: query
  })
}

export function goodsListByGoodsId(query) {
  return requestNoToken({
    url: '/index/goodsListByGoodsId',
    method: 'get',
    params: query
  })
}

export function dashboard(userId) {
  return request({
    url: '/mycount/dashboard',
    method: 'get',
    params: {userId}
  })
}

export function selectListByType(query) {
  return requestNoToken({
    url: '/index/goodsListByType',
    method: 'get',
    params: query
  })
}
export function selectBanner(query) {
  return requestNoToken({
    url: '/index/adList',
    method: 'get',
    params: query
  })
}

export function hotWordByCode(query) {
  return requestNoToken({
    url: '/index/hotWordByCode',
    method: 'get',
    params: query
  })
}

export function addGoodsCar(data) {
  return request({
    url: '/car/addGoodsCar',
    method: 'post',
    data
  })
}

export function goodsListByGoodsIdAndWish(query) {
  return requestNoToken({
    url: '/index/goodsListByGoodsIdAndWish',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js